import { Radio as RadioPrimitive } from "@base-ui/react/radio"
import { RadioGroup as RadioGroupPrimitive } from "@base-ui/react/radio-group"

import { cn } from "@/modules/lib/utils"

function RadioGroup({ className, ...props }: RadioGroupPrimitive.Props) {
  return (
    <RadioGroupPrimitive
      data-slot="radio-group"
      className={cn("grid w-full gap-3", className)}
      {...props}
    />
  )
}

function RadioGroupItem({ className, ...props }: RadioPrimitive.Root.Props) {
  return (
    <RadioPrimitive.Root
      data-slot="radio-group-item"
      className={cn(
        // Base
        "group/radio-group-item peer relative flex aspect-square size-5 shrink-0 rounded-full",
        // Border — unchecked
        "border border-interactive-border-neutral-default data-checked:border-5",
        // Shadow & transition
        "shadow-xs transition-[color,box-shadow,background-color]",
        // Touch target
        "outline-none after:absolute after:-inset-x-3 after:-inset-y-2",
        // Hover — unchecked
        "hover:border-interactive-border-neutral-highlighted hover:bg-interactive-background-neutral-highlighted",
        // Focus
        "focus-visible:ring-[3px] focus-visible:ring-interactive-border-neutral-highlighted",
        // Disabled
        "disabled:cursor-not-allowed disabled:border-interactive-border-neutral-disabled",
        // Checked
        "data-checked:border-interactive-background-primary-default",
        // Checked — hover
        "data-checked:hover:border-interactive-background-primary-highlighted",
        // Checked — focus
        "data-checked:focus:ring-interactive-background-primary-faded",
        // Checked — disabled
        "data-checked:disabled:border-interactive-background-primary-disabled",
        // Invalid — unchecked
        "aria-invalid:border-interactive-border-negative-default",
        // Invalid — hover
        "aria-invalid:hover:border-interactive-border-negative-default aria-invalid:hover:bg-interactive-background-negative-default",
        // Invalid — focus
        "aria-invalid:focus:ring-interactive-background-negative-faded",
        className,
      )}
      {...props}
    >
      <RadioPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex size-2.5 items-center justify-center"
      >
        {/* Dot : primary (yellow-green) par défaut, red en état error */}
        <span
          className={cn(
            "absolute top-1/2 left-1/2 size-2.5 -translate-x-1/2 -translate-y-1/2 rounded-full",
            "bg-white",
            "group-aria-invalid/radio-group-item:bg-borderError",
          )}
        />
      </RadioPrimitive.Indicator>
    </RadioPrimitive.Root>
  )
}

export { RadioGroup, RadioGroupItem }
